var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31324 14.8715L21.1319 6.31597C22.2896 5.64757 23.8027 6.05299 24.4711 7.2107L25.0822 8.26918L6.02962 19.2692L5.41851 18.2107C4.75011 17.053 5.12246 15.559 6.31324 14.8715ZM26.9155 11.4446L30.5822 17.7955C31.2697 18.9862 30.8452 20.4662 29.6875 21.1346L14.8688 29.6902C13.678 30.3777 12.2171 29.9862 11.5296 28.7955L7.86296 22.4446L26.9155 11.4446ZM14.0121 24.5396C13.7144 24.7115 13.6356 25.1098 13.7884 25.3744C13.9603 25.6721 14.3255 25.77 14.6232 25.5981L16.7401 24.3759C17.0047 24.2231 17.1357 23.8388 16.9638 23.5411C16.811 23.2765 16.3936 23.1646 16.129 23.3174L14.0121 24.5396ZM18.0223 22.93C18.1942 23.2277 18.5594 23.3255 18.8571 23.1536L23.091 20.7092C23.3556 20.5564 23.4865 20.1721 23.3147 19.8744C23.1619 19.6098 22.7445 19.4979 22.4799 19.6507L18.246 22.0952C17.9483 22.267 17.8695 22.6653 18.0223 22.93Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.e7e4759150904248e9465820b4e41557.svg";
export { ForwardRef as ReactComponent };